import {nextTick, unref, watch} from 'vue';
import {useDataSourceStore} from "@/store/modules/dataSourceStore";
import {storeToRefs} from "pinia";
import {usePcSpaceStore} from "@/store/pcSpaceStore";
import {PageEnum} from "@/enums/pageEnum";
import {usePageModelsStore} from "@/store/modules/pageModels";


export default function ({initCtlData, borderConfig, dataConfig, showFlag,loadingFlag,sectionConfig}:any) {
  const dataSourceStore = useDataSourceStore();
  const pageModelsStore = usePageModelsStore();
  const {dataListCache}: any = storeToRefs(dataSourceStore);

  //变更timer
  let changTimer: any = null

  const watchDesConfig = function () {
    /**
     * 监听显示隐藏变化
     */
    watch([showFlag, dataConfig], (newVal) => {
      if (changTimer != null) {
        clearTimeout(changTimer);
      }
      changTimer = setTimeout(() => {
        initCtlData && initCtlData({});
      }, 50)
    }, {
      deep: true, // 深度监听
    })

    // 监听宽高变化
    watch([() => unref(borderConfig).height,() => unref(sectionConfig)&&unref(sectionConfig).defaultValue, () => unref(borderConfig).width], (newV) => {
      console.log(newV, "======2");
      if (changTimer != null) {
        clearTimeout(changTimer);
      }
      changTimer = setTimeout(() => {
        initCtlData && initCtlData({});
      }, 50)

    }, {
      deep: true, // 深度监听
    });
  }

  const watchDataConfig = function () {
    // 监听内容变化
    watch(() => {
        return unref(dataListCache)[unref(dataConfig).selId];
      }, (newVal) => {
        if (newVal != null) {
          if (changTimer != null) {
            clearTimeout(changTimer);
          }
          changTimer = setTimeout(() => {
            initCtlData && initCtlData({});
          }, 50)
        }
      }, {
        deep: true, // 深度监听
      }
    );
    // 边框tab发生变化
    watch([() => unref(borderConfig).activeKey], (newV) => {
      if (changTimer != null) {
        clearTimeout(changTimer);
      }
      changTimer = setTimeout(() => {
        initCtlData && initCtlData({});
      }, 50)

    }, {
      deep: true, // 深度监听
    });
  }

  if (window.appObj.isDes) {
    //目的延时执行监听 减少重复查询
    nextTick(() => {
      watchDataConfig();
      watchDesConfig();
    })
  } else {
    watchDataConfig();
  }

  //刷新列表数据信息
  const flushChart = function (inParams) {
    //如果是通过选择外部数据源 则刷新数据
    if (unref(dataListCache)[unref(dataConfig).selId]) {
      loadingFlag.value=true;
      dataSourceStore.removeCacheByCode(unref(dataConfig).selId);
      dataSourceStore.getDatasByQueryCode(unref(dataConfig).selId, pageModelsStore, () => {
       nextTick(()=>{
         loadingFlag.value=false;
       })
      })
    } else {
      initCtlData && initCtlData(inParams);
    }
  }

  return {
    flushChart,
    watchDesConfig,
    watchDataConfig
  }
}
